import styled from 'styled-components';
import Button from '../../components/BuildingBlocks/Button';
import Text from '../../components/BuildingBlocks/Text';
import { media } from '../../components/css';

/**
 * Styles for the MSA html.
 */
export const Heading = styled(Text.HeadingFourth)`
  margin: 1em 0 0.2em 0;

  &:first-of-type {
    margin-top: 0;
  }
`;

export const Paragraph = styled(Text.CopyParagraph)`
  margin: 0 0 1em 0;
`;

export const OrderedList = styled.ul`
  margin: 0 0 0 1em;
  list-style-type: decimal;
`;

export const UnorderedList = styled.ul`
  margin: 0 0 0 1em;
  list-style-type: disc;
`;

export const ListItem = styled(Text.CopyParagraph)`
  margin: 0 0 0.5em 0;
`;

export const SubmitButton = styled(Button)`
  display: block;
  width: 100%;
  margin-bottom: 20px;

  ${media.greaterThan('md')`
    display: inline-block;
    width: auto;
  `};
`;
